/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * CaptainBoatsApi - axios parameter creator
 * @export
 */
export const CaptainBoatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate a boat to captain. A boat must have a captained package.
         * @param {string} id The public boat id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CaptainBoatsIdActivatePut: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CaptainBoatsIdActivatePut', 'id', id)
            const localVarPath = `/domestic/v2/captain/boats/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a boat to captain.
         * @param {string} id The public boat id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CaptainBoatsIdDeactivatePut: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CaptainBoatsIdDeactivatePut', 'id', id)
            const localVarPath = `/domestic/v2/captain/boats/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaptainBoatsApi - functional programming interface
 * @export
 */
export const CaptainBoatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaptainBoatsApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate a boat to captain. A boat must have a captained package.
         * @param {string} id The public boat id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CaptainBoatsIdActivatePut(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CaptainBoatsIdActivatePut(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deactivate a boat to captain.
         * @param {string} id The public boat id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CaptainBoatsIdDeactivatePut(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CaptainBoatsIdDeactivatePut(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CaptainBoatsApi - factory interface
 * @export
 */
export const CaptainBoatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaptainBoatsApiFp(configuration)
    return {
        /**
         * Activate a boat to captain. A boat must have a captained package.
         * @param {string} id The public boat id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CaptainBoatsIdActivatePut(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.domesticV2CaptainBoatsIdActivatePut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a boat to captain.
         * @param {string} id The public boat id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CaptainBoatsIdDeactivatePut(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.domesticV2CaptainBoatsIdDeactivatePut(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaptainBoatsApi - interface
 * @export
 * @interface CaptainBoatsApi
 */
export interface CaptainBoatsApiInterface {
    /**
     * Activate a boat to captain. A boat must have a captained package.
     * @param {string} id The public boat id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaptainBoatsApiInterface
     */
    domesticV2CaptainBoatsIdActivatePut(id: string, options?: AxiosRequestConfig): AxiosPromise<object>;

    /**
     * Deactivate a boat to captain.
     * @param {string} id The public boat id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaptainBoatsApiInterface
     */
    domesticV2CaptainBoatsIdDeactivatePut(id: string, options?: AxiosRequestConfig): AxiosPromise<object>;

}

/**
 * CaptainBoatsApi - object-oriented interface
 * @export
 * @class CaptainBoatsApi
 * @extends {BaseAPI}
 */
export class CaptainBoatsApi extends BaseAPI implements CaptainBoatsApiInterface {
    /**
     * Activate a boat to captain. A boat must have a captained package.
     * @param {string} id The public boat id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaptainBoatsApi
     */
    public domesticV2CaptainBoatsIdActivatePut(id: string, options?: AxiosRequestConfig) {
        return CaptainBoatsApiFp(this.configuration).domesticV2CaptainBoatsIdActivatePut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a boat to captain.
     * @param {string} id The public boat id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaptainBoatsApi
     */
    public domesticV2CaptainBoatsIdDeactivatePut(id: string, options?: AxiosRequestConfig) {
        return CaptainBoatsApiFp(this.configuration).domesticV2CaptainBoatsIdDeactivatePut(id, options).then((request) => request(this.axios, this.basePath));
    }
}
